<template>
    <div>
        <infinity-separator
            icon="$vuetify.icon.universe"
            :text="universe.id"
        >
            <universe-edit-button 
                :universe="universe.id"
            />
        </infinity-separator>
        <v-row>
            <v-col
                v-for="app in apps.items.filter(app => app.id.toLowerCase().includes(query.toLowerCase()))"
                :key="`app-${app.id}`"
                cols="12"
                md="4"
                lg="3"
            >
                <has-app 
                    :app="app.name" 
                    :universe="app.universe"
                >
                    <infinity-app-card
                        :app="app"
                        :title="app.id"
                        :small="true"
                    >
                        <template #subtitle>                        
                            <div class="font-weight-light text--secondary">
                                <div class="font-weight-light text--secondary">
                                    <div>
                                        <v-icon size="14">
                                            $universe
                                        </v-icon> 
                                        {{ app.universe }}
                                    </div>
                                </div>
                                <div 
                                    v-if="repository(app)" 
                                    class="subtitle"
                                >
                                    <v-icon size="14">
                                        mdi-git
                                    </v-icon> 
                                    {{ repository(app) }} / {{ branch(app) }}
                                </div>
                            </div>                        
                        </template>

                        <template #actions>
                        <v-icon
                            class="mr-1"
                            small
                        >
                            mdi-clock-outline
                        </v-icon>
                        <span
                            class="text-caption grey--text font-weight-light"
                            v-text="timestamp(app)"
                        />
                        </template>
                    </infinity-app-card>
                
                    <template #fallback>
                        <material-card                        
                                style="position: relative;"        
                                progress-color="white"
                                icon="$vuetify.icons.app"
                                color="primary"
                                hover                      
                            >
                            <template #title>
                                <v-card 
                                    flat              
                                    style="position: sticky; top: 0;align-self: flex-start"
                                >
                                    <h1
                                        class="infinity-text"
                                        style="font-weight: 400"
                                        v-html="app.data.name"
                                    />
                                    <h2 
                                        style="font-weight: 300"
                                        v-html="app.data.subtitle || '&nbsp;'"
                                    />
                                    <v-card-actions
                                        class="pr-12 pt-5"
                                    />
                                </v-card>
                            </template>
                            <v-card-text 
                                style="color: rgb(51, 51, 51)"
                                v-html="description(app.data.description || '')" 
                            />
                            <v-card-actions>
                                <v-spacer />
                                <v-btn
                                    :href="link(app)"
                                    x-large
                                    block
                                    depressed
                                    dark
                                    color="orange"
                                >
                                    <v-icon 
                                        left 
                                    >
                                        mdi-link
                                    </v-icon>
                                    Visit application
                                </v-btn>
                            </v-card-actions>
                        </material-card>    
                    </template>
                </has-app>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapActions, mapState } from 'pinia'
import { useAppStore } from '@/store/app-store'
import { marked } from 'marked'
import UniverseEditButton from '@/layouts/Universe/widgets/EditButton'

export default {
    name: 'UniverseDashboard',
    components: {
        UniverseEditButton,
    },
    props: {
        universe: Object,
        query: String,
    },
    data: () => {
        return {
            apps: { items: [] },           
        }
    },
    computed: {        
        ...mapState(useAppStore, ['allApps']),
    },
    watch: {
        allApps (v) {            
            const items = []
            Object.entries(v || {}).map(entry => {
                const [key, value] = entry
                if (key.startsWith(`${this.universe.id}-`)) {
                    items.push(value)
                }
            })
            this.apps = {
                items: items,
            }
        },
    },
    async mounted () {
        const items = []
        Object.entries(this.allApps || {}).map(entry => {
            const [key, value] = entry
            if (key.startsWith(`${this.universe.id}-`)) {
                items.push(value)
            }
        })
        this.apps = {
            items: items,
        }
    },
    methods: {
        ...mapActions(useAppStore, ['loadApps']),
        description (md) {
            return marked(md || '')
        },
        repository (app) {
            return app?.data?.app?.buildConfig?.repository
        },
        branch (app) {
            return app?.data?.app?.buildConfig?.branch
        },
        link (app) {
            const host = window.location.host
            return `https://${app.name}-${app.universe}.${host}`
        },
    },
}
</script>
